import { render, staticRenderFns } from "./SegmentWrapper.vue?vue&type=template&id=7390b190&scoped=true&"
import script from "./SegmentWrapper.vue?vue&type=script&lang=js&"
export * from "./SegmentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SegmentWrapper.vue?vue&type=style&index=0&id=7390b190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390b190",
  null
  
)

export default component.exports